import { useLayoutEffect, useRef, type ReactNode } from 'react'
import { reducedMotion } from '../lib/springDrag.ts'

/**
 * Text, ktery kratce poskoci, kdyz se zmeni `trigger` — pocet polozek obchodu
 * po presunu. Pri prvnim vykresleni ani s omezenym pohybem se nehybe.
 */
export function Bump({
  trigger,
  className,
  children,
}: {
  trigger: number
  className?: string | undefined
  children: ReactNode
}) {
  const ref = useRef<HTMLSpanElement>(null)
  const previous = useRef(trigger)

  useLayoutEffect(() => {
    if (previous.current === trigger) return
    previous.current = trigger
    const el = ref.current
    if (!el || reducedMotion()) return
    el.classList.remove('count-bump')
    void el.offsetWidth
    el.classList.add('count-bump')
  }, [trigger])

  return (
    <span ref={ref} className={className} onAnimationEnd={(e) => e.currentTarget.classList.remove('count-bump')}>
      {children}
    </span>
  )
}
